// ==========================================================
// FILE: src/modules/pms/services/wbsService.js
// ==========================================================

import axiosClient from "../../../api/axiosClient";

// ---------------------------------------------------------
// CREATE NODE
// ---------------------------------------------------------
export const createWBSNode = (payload) => {
  return axiosClient.post("/api/pms/wbs/create", payload);
};

// ---------------------------------------------------------
// GET TREE
// ---------------------------------------------------------
export const getWBSTree = (projectId) => {
  return axiosClient.get(`/api/pms/wbs/tree/${projectId}`);
};

// ---------------------------------------------------------
// UPDATE NODE DATES
// ---------------------------------------------------------
export const updateNodeDates = (data) => {
  return axiosClient.post(`/api/pms/wbs/update-dates`, data);
};

export const createWBSDependency = (data) => {
  return axiosClient.post("/api/pms/wbs/dependency/create", data);
};

export const getWBSDependencies = (projectId) => {
  return axiosClient.get(`/api/pms/wbs/dependency/${projectId}`);
};

// =========================================================
// 🔥 UPDATE WBS NODE (EDIT)
// =========================================================
export const updateWBSNode = (payload) => {
  return axiosClient.post("/api/pms/wbs/update", payload);
};

// =========================================================
// 🔥 DELETE WBS NODE
// =========================================================
export const deleteWBSNode = (nodeId) => {
  return axiosClient.delete(`/api/pms/wbs/${nodeId}`);
};